import React, { useContext } from "react";
import { ActionIcon } from "rizzui/action-icon";
import { Text } from "rizzui/typography";
import EditIcon from "../../../assets/edit";
import { Button } from "rizzui/button";
import { useNavigate } from "react-router";
import {
  useSingleAvailability,
  useSingleCampaign,
} from "../../../hooks/useCampaign";
import { convertTo12Hour } from "../../../lib/utils/convertTo24hrs";
import useFetchData from "../../../hooks/useFetchData";
import { useUserPhones } from "../../../hooks/useProfileDetails";
import { useModal } from "../../../hooks/useModal";
import CampaignTestModal from "../../../component/campaignTest";
import axios from "axios";
import { baseUrl } from "../../account/login";
import { AuthContext } from "../../../context/authContext";

export default function PreviewPage({ data }) {
  const { setDone, isEdit, currentId, setPage } = data;
  const navigate = useNavigate();
  const { token } = useContext(AuthContext);
  // const [startDate, setStartDate] = React.useState<Date | null>();
  const { data: documents } = useFetchData({ dataType: "knowledgebase" });
  const { data: numbers } = useUserPhones();
  const { data: campaign } = useSingleCampaign({ id: currentId });
  const { data: availability } = useSingleAvailability({ id: currentId });
  const labelClassName = "font-switzer font-[400] text-[12px] text-[#758599]";
  const valueClassName =
    "font-switzer font-[400] text-[14px] text-primary-dark break-words";
  const titleClassName =
    "font-ibmPlexSerif font-[600] text-[15px] text-primary-dark";
  const boxClassName =
    "rounded-[4px] border-[#758599] border-dashed border p-[16px] flex flex-col gap-[16px]";

  const handleSubmit = async () => {
    await axios
      .put(
        `${baseUrl}/campaigns/start_campaign/${currentId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        if (response.status === 201) {
          sessionStorage.removeItem("new_campaign_page");
          sessionStorage.removeItem("campaign_id");
          sessionStorage.removeItem("call_time");
          if (isEdit) {
            navigate("/campaigns");
          } else {
            setDone(true);
          }
        }
      });
  };

  const { openModal } = useModal();

  const handleTest = () => {
    currentId &&
      openModal({
        view: <CampaignTestModal campaign_id={currentId} />,
      });
  };

  return (
    <div className="h-full w-full mb-5 flex flex-row justify-between flex-wrap gap-[100px]">
      <div className="rounded-[8px] md:px-[32px] md:w-[460px] xl:mx-0 mx-auto md:py-[28px] p-[20px] border-[0.5px] border-muted">
        <div className="flex flex-col gap-[28px]">
          <div className="flex flex-col gap-[15px]">
            <Text className={titleClassName}>Campaign details</Text>
            <div className={boxClassName}>
              <div className="flex justify-between">
                <div>
                  <Text className={labelClassName}>Campaign name</Text>
                  <Text className={valueClassName}>
                    {campaign?.campaign_name}
                  </Text>
                </div>
                <ActionIcon
                  className="!p-0 !m-0 !h-fit w-[45px] !bg-transparent flex gap-[8px]"
                  onClick={() => setPage(0)}
                >
                  <EditIcon className={"text-primary-dark size-[16px]"} />
                  <Text
                    className={`${labelClassName} !font-[500] !text-primary-dark`}
                  >
                    Edit
                  </Text>
                </ActionIcon>
              </div>

              <div>
                <Text className={labelClassName}>Campaign type</Text>
                <Text className={valueClassName}>
                  {campaign?.campaign_type}
                </Text>
              </div>

              <div className="w-[229px]">
                <Text className={labelClassName}>Description</Text>
                <Text className={valueClassName}>
                  {campaign?.campaign_description}
                </Text>
              </div>

              <div className="w-[229px]">
                <Text className={labelClassName}>About your business</Text>
                <Text className={valueClassName}>
                  {campaign?.about_business}
                </Text>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-[15px]">
            <Text className={titleClassName}>AI assistant</Text>
            <div className={boxClassName}>
              <div className="flex justify-between">
                <div>
                  <Text className={labelClassName}>AI Agent name</Text>
                  <Text className={valueClassName}>
                    {campaign?.ai_agent_name}
                  </Text>
                </div>
                <ActionIcon
                  className="!p-0 !m-0 !h-fit w-[45px] !bg-transparent flex gap-[8px]"
                  onClick={() => setPage(1)}
                >
                  <EditIcon className={"text-primary-dark size-[16px]"} />
                  <Text
                    className={`${labelClassName} !font-[500] !text-primary-dark`}
                  >
                    Edit
                  </Text>
                </ActionIcon>
              </div>

              <div>
                <Text className={labelClassName}>AI Agent role</Text>
                <Text className={valueClassName}>
                  {campaign?.ai_agent_role}
                </Text>
              </div>

              <div className="w-[250px]">
                <Text className={labelClassName}>AI Voice</Text>
                <Text className={valueClassName}>
                  {campaign?.ai_agent_voice_details?.name} - (
                  {campaign?.ai_agent_voice_details?.labels?.gender?.replace(
                    /\b\w/g,
                    (char) => char.toUpperCase()
                  )}
                  ),{" "}
                  {campaign?.ai_agent_voice_details?.labels?.description?.replace(
                    /\b\w/g,
                    (char) => char.toUpperCase()
                  )}{" "}
                  ,{" "}
                  {campaign?.ai_agent_voice_details?.labels?.accent?.replace(
                    /\b\w/g,
                    (char) => char.toUpperCase()
                  )}
                  ,{" "}
                  {campaign?.ai_agent_voice_details?.labels?.age
                    ?.replace(/\b\w/g, (char) => char.toUpperCase())
                    ?.replace("_", " ")}
                </Text>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-[15px]">
            <Text className={titleClassName}>Call details</Text>
            <div className={boxClassName}>
              <div className="flex justify-between">
                <div className="w-[300px]">
                  <Text className={labelClassName}>Reason for the call</Text>
                  <Text className={valueClassName}>
                    {campaign?.call_reason}
                  </Text>
                </div>
                <ActionIcon
                  className="!p-0 !m-0 !h-fit w-[45px] !bg-transparent flex gap-[8px]"
                  onClick={() => setPage(2)}
                >
                  <EditIcon className={"text-primary-dark size-[16px]"} />
                  <Text
                    className={`${labelClassName} !font-[500] !text-primary-dark`}
                  >
                    Edit
                  </Text>
                </ActionIcon>
              </div>

              <div className="w-[300px]">
                <Text className={labelClassName}>Goal of the call</Text>
                <Text className={valueClassName}>{campaign?.call_goal}</Text>
              </div>

              {campaign?.greeting_after_pickup === "greeting_myself" && (
                <div className="w-[300px]">
                  <Text className={labelClassName}>Greetings after pickup</Text>
                  <Text className={valueClassName}>
                    {campaign?.greeting_message}
                  </Text>
                </div>
              )}

              <div className="w-[300px]">
                <Text className={labelClassName}>
                  What are your qualification questions
                </Text>
                <Text className={valueClassName}>
                  {campaign?.qualification_questions}
                </Text>
              </div>

              <div className="w-[300px]">
                <Text className={labelClassName}>Knowledge base</Text>

                {campaign?.knowledge_base?.map((doc) => (
                  <Text className={valueClassName}>
                    {
                      documents?.data?.find((base) => base?._id === doc)
                        ?.document_name
                    }{" "}
                    (
                    {documents?.data?.find((base) => base?._id === doc)
                      ?.knowledgebase_query ?? ""}
                    )
                  </Text>
                ))}
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-[15px]">
            <Text className={titleClassName}>Call availability</Text>
            <div className={`${boxClassName} !gap-[28px]`}>
              <div className="flex flex-col gap-[16px]">
                <div className="flex justify-between">
                  <div className="w-[300px]">
                    <Text className={`${titleClassName} !text-[14px]`}>
                      AI call time
                    </Text>
                  </div>
                  <ActionIcon
                    className="!p-0 !m-0 !h-fit w-[45px] !bg-transparent flex gap-[8px]"
                    onClick={() => setPage(3)}
                  >
                    <EditIcon className={"text-primary-dark size-[16px]"} />
                    <Text
                      className={`${labelClassName} !font-[500] !text-primary-dark`}
                    >
                      Edit
                    </Text>
                  </ActionIcon>
                </div>

                <div className="w-[300px]">
                  <Text className={labelClassName}>Timezone</Text>
                  <Text className={valueClassName}>
                    {campaign?.availability?.timezone_ask ? "Ask" : "Don't ask"}
                  </Text>
                </div>

                <div className="w-[300px]">
                  <Text className={labelClassName}>Call time</Text>
                  <div className="flex flex-col gap-[4px] !mt-0 w-[238px]">
                    {campaign?.availabilityDetails?.weeklyAvailability
                      ?.sort((a, b) => {
                        const daysOrder = [
                          "Monday",
                          "Tuesday",
                          "Wednesday",
                          "Thursday",
                          "Friday",
                          "Saturday",
                          "Sunday",
                        ];
                        return (
                          daysOrder.indexOf(a?.day) - daysOrder.indexOf(b?.day)
                        );
                      })
                      .map((day) => (
                        <div className="flex justify-between">
                          <Text className={valueClassName}>{day?.day};</Text>
                          <Text className={valueClassName}>
                            {convertTo12Hour(day?.slots[0]?.start)} -{" "}
                            {convertTo12Hour(day?.slots[0]?.end)}
                          </Text>
                        </div>
                      ))}
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-[16px]">
                <div className="w-[300px]">
                  <Text className={`${titleClassName} !text-[14px]`}>
                    Your calendar availability
                  </Text>
                </div>

                <div className="w-[300px]">
                  <Text className={labelClassName}>Call time</Text>
                  <div className="flex flex-col gap-[4px] w-[238px]">
                    {availability?.data
                      ?.sort((a, b) => {
                        const daysOrder = [
                          "Monday",
                          "Tuesday",
                          "Wednesday",
                          "Thursday",
                          "Friday",
                          "Saturday",
                          "Sunday",
                        ];
                        return (
                          daysOrder.indexOf(a?.day) - daysOrder.indexOf(b?.day)
                        );
                      })
                      .map((day) => (
                        <div className="flex justify-between">
                          <Text className={valueClassName}>{day?.day};</Text>
                          <Text className={valueClassName}>
                            {convertTo12Hour(day?.start_time)} -{" "}
                            {convertTo12Hour(day?.end_time)}
                          </Text>
                        </div>
                      ))}
                  </div>
                </div>
              </div>

              <div className="w-[300px]">
                <Text className={labelClassName}>Phone number</Text>
                {campaign?.campaign_phone_numbers?.map((phone) => (
                  <Text className={valueClassName}>
                    {
                      numbers?.data?.find((number) => number?._id === phone)
                        ?.phone_number
                    }
                  </Text>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-[371px] xl:mx-0 mx-auto h-[268px] border-[.5px] border-muted rounded-[8px] md:p-[32px] p-[20px] flex flex-col justify-between">
        <div>
          <Text className="font-ibmPlexSerif font-[600] text-primary-dark text-[15px]">
            Test and {isEdit ? "save" : " submit"} campaign
          </Text>
          <Text className="font-switzer text-[12px] text-[#758599] font-[400]">
            We recommend you test the campaign to see how it works before you
            submit
          </Text>
        </div>

        {/*         <div className="flex flex-col gap-[8px]">
          <Text className={labelClassName}>
            When do you want your campaign to go live
          </Text>
          <ReactDatePicker
            selected={startDate}
            onChange={(date: Date | null) => setStartDate(date)}
            dateFormat="d MMMM yyyy, h:mm aa"
            placeholderText="DD/MM/YYY-00:00"
            showTimeSelect
            suffix={
              <AppointmentIcon
                className={"text-[#758599] size-[16px] stroke-1"}
              />
            }
          />
        </div> */}
        <div className="flex flex-col gap-[17px]">
          <Button
            className="!bg-btn text-background rounded-[4px] !w-[305px] !h-[40px] font-switzer font-[500] text-[12px]"
            onClick={handleSubmit}
          >
            {isEdit ? "Save" : "Submit"} campaign
          </Button>

          <Button
            onClick={() => handleTest()}
            className="dark:!bg-muted dark:!text-[#D9D9D9] text-primary-dark !bg-[#F2F2F2] rounded-[4px] w-[305px] h-[40px] font-switzer font-[500] text-[12px]"
          >
            Test the campaign
          </Button>
        </div>
      </div>
    </div>
  );
}
